define('dispatcher',['jquery', 'event-manager', 'underscore', 'lib'], function($, eventManager, _, lib) {
    'use strict';

    // Events listeners
    var state = {};

    // If we attach event handlers for the *-loaded events after the event has already been fired, trigger the handler right away
    _.each([
        'domready',
        'e24-front-loaded',
        'e24-lunch-loaded',
        'e24-not-found-loaded',
        'e24-podcast-loaded',
        'e24-tpn-loaded',
        'e24-contact-form-loaded',
        'e24-salesposter-loaded',
    ], function(item) {
        eventManager.on('event-handler-attached:' + item, function(e, handler) {
            if (state[item]) {
                _.defer(handler, null);
            }
        });
    });

    var dispatcher = {
        dispatched: false,

        checkReady: function() {
            if ($('#footer').length) {
                this.dispatch();
                return true;
            }

            return false;
        },

        startReadyTimer: function() {
            if (this.timer) {
                clearInterval(this.timer);
            }

            if (!this.checkReady()) {
                this.timer = setInterval(this.checkReady, 50);
            }
        },

        stopReadyTimer: function() {
            clearInterval(this.timer);
        },

        onElement: function onElement(selector, cb, poll) {
            var el = $(selector);
            if (el.length) {
                cb(el);
            } else if (document.readyState !== 'complete') {
                _.delay(onElement, poll || 10, selector, cb);
            }
        },

        dispatch: function() {
            if (this.dispatched) {
                return;
            }

            this.dispatched = true;
            this.stopReadyTimer();

            state.domready = true;
            eventManager.emit('domready');

            var body = lib.$body();
            if (body.hasClass('front') || body.hasClass('section') || body.hasClass('section-keyword') || body.hasClass('interactive')) {
                state['e24-front-loaded'] = true;
                eventManager.emit('e24-front-loaded');
            } else if (body.hasClass('lunch')) {
                state['e24-lunch-loaded'] = true;
                eventManager.emit('e24-lunch-loaded');
            } else if (body.hasClass('salesposter') || body.hasClass('salesposter-paywall')) {
                state['e24-salesposter-loaded'] = true;
                eventManager.emit('e24-salesposter-loaded');
            } else if (body.hasClass('not-found')) {
                state['e24-not-found-loaded'] = true;
                eventManager.emit('e24-not-found-loaded');
            } else if (body.hasClass('podcasts-podcast') || body.hasClass('podcasts-podcast-episode')) {
                state['e24-podcast-loaded'] = true;
                eventManager.emit('e24-podcast-loaded');
            } else if (body.hasClass('tpn-meeting')) {
                state['e24-tpn-loaded'] = true;
                eventManager.emit('e24-tpn-loaded');
            }

            $(function() {
                if (lib.$('.contact-form').length) {
                    eventManager.emit('e24-contact-form-loaded');
                }
            });
        }
    };

    _.bindAll(dispatcher, _.methods(dispatcher));

    // Start a ready-timer check
    dispatcher.startReadyTimer();

    // Listen for domReady event and fire off events
    var $document = lib.$document();
    $document.on('readystatechange', function() {
        if (document.readyState === 'interactive') {
            dispatcher.dispatch();
        }
    });
    $document.ready(dispatcher.dispatch);

    return dispatcher;
});

